//require('file-loader?name=[name].[ext]!./index.html');
import React, { Fragment } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render( 
  <Fragment>
    <App />
  </Fragment>
  ,
  // document.getElementById('root')
);

